import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { LikesProvider } from './context/LikesContext';
import { ToastProvider } from './context/ToastContext';
import { ScrollToTop } from './components/utility/ScrollToTop';

// A data router lets edit forms block navigation when they have unsaved changes.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <>
        <ScrollToTop />
        <AuthProvider>
          <LikesProvider>
            <CartProvider>
              <ToastProvider>
                <AppRoutes />
              </ToastProvider>
            </CartProvider>
          </LikesProvider>
        </AuthProvider>
      </>
    ),
  },
], { basename: __BASE_PATH__ });

export default function App() {
  return <RouterProvider router={router} />;
}
